<template>
    <div class="customization-management">
      <!-- Header -->
      <AppHeader title="Product Customization" />
  
      <!-- Add New Customization Button -->
      <button class="add-customization-btn" @click="addNewCustomization">
        Add New Customization
      </button>
  
      <!-- Table Structure -->
      <table id="customizationTable">
        <thead>
          <tr>
            <th>ID</th>
            <th>Name</th>
            <th>ERP Item</th>
            <th>Price</th>
            <th>Default</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="customization in customizations" :key="customization.id">
            <td>{{ customization.id }}</td>
            <td>{{ getLocalizedName(customization.languages) }}</td>
            <td>{{ customization.ERP_Item }}</td>
            <td>{{ customization.price }}</td>
            <td>{{ customization.defaults ? 'Yes' : 'No' }}</td>
            <td class="action-buttons">
              <button data-tooltip="Edit" @click="handleEdit(customization)">
                <img src="@/assets/edit_icon.png" alt="Edit">
              </button>
              <button data-tooltip="Delete" @click="handleDelete(customization)">
                <img src="@/assets/delete_icon.png" alt="Delete">
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </template>
  
  <script>
  import axios from 'axios';
  
  export default {
    data() {
      return {
        customizations: [],
        currentDate: "",
        currentTime: "",
        token: null,
        productId: null,
        userLangId: 2, 
        userName: "",
        price: null,
        restaurantName: ""
      };
    },
    mounted() {
      this.price = this.$route.params.price;
      console.log(this.price);
      this.productId = this.$route.params.id;
      console.log(this.$route.params.id);
      this.token = localStorage.getItem('authToken');
      const userData = JSON.parse(localStorage.getItem('userData'));
      
      // Set user language preference
      this.userLangId = userData?.user?.langId || 2;
      this.userName = userData?.user?.name || "";
      this.restaurantName = localStorage.getItem('restaurantName') || "";
  
      this.updateDateTime();
      setInterval(this.updateDateTime, 1000);
      this.fetchCustomizations();
    },
    methods: {
      async fetchCustomizations() {
        try {
          this.$root.isLoading = true; 
          this.loading = true;
          const response = await axios.get(
            `${this.$BASE_API_URL}/api/product_customizations/${this.productId}`,
            {
              headers: {
                Authorization: `Bearer ${this.token}`,
              },
            }
          );
  
          if (response.data.status) {
            this.customizations = response.data.data;
          }
        } catch (error) {
          console.error("Error fetching customizations:", error);
          this.$toast.error("Failed to load customizations. Please try again.");
        }
        finally {
      this.$root.isLoading = false;
      this.loading = false;
    }
      },
  
      getLocalizedName(languages) {
        const langItem = languages.find(lang => lang.langId === this.userLangId);
        
        return langItem?.name || (languages.length > 0 ? languages[0].name : 'N/A');
      },
  
      updateDateTime() {
        const now = new Date();
        this.currentDate = now.toLocaleDateString("en-GB", {
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
        });
        this.currentTime = now.toLocaleTimeString("en-US", {
          hour: "2-digit",
          minute: "2-digit",
          hour12: true,
        });
      },
  
      addNewCustomization() {
        if (!this.$hasPermission('create customizations')){
        this.$toast.error('Not Permitted');
        return;
    }
        this.$router.push({ 
          name: 'AddCustomProductComponent', 
          params: { prodId: this.productId, price: this.price } 
        });
      },
  
      handleEdit(customization) {
         if (!this.$hasPermission('edit customizations')){
        this.$toast.error('Not Permitted');
        return;
    }
        this.$router.push({ 
          name: 'EditCustomProductComponent', 
          params: { id: customization.id } 
        });
      },
  
      async handleDelete(customization) {
         if (!this.$hasPermission('delete customizations')){
        this.$toast.error('Not Permitted');
        return;
    }
        if (confirm(`Delete customization "${this.getLocalizedName(customization.languages)}"?`)) {
          try {
            this.$root.isLoading = true; 
            this.loading = true;
            const response = await axios.delete(
              `${this.$BASE_API_URL}/api/customizations/${customization.id}`,
              {
                headers: {
                  Authorization: `Bearer ${this.token}`,
                },
              }
            );
  
            if (response.data.error) {
              this.$toast.error("Failed to delete customization: " + 
                (response.data.message || "Unknown error"));
            } else {
              this.fetchCustomizations();
              this.$toast.success("Customization deleted successfully!");
            }
          } catch (error) {
            console.error("Error deleting customization:", error);
            this.$toast.error(error.response?.data?.message || "Deletion failed. Please try again.");
          }
          finally {
      this.$root.isLoading = false;
      this.loading = false;
    }
        }
      },
    },
  };
  </script>
  
  <style scoped>
  
  th, td {
    border: 1px solid;
    padding: 8px;
    text-align: left;
  }
  
  .add-customization-btn {
    float: right;
    margin-bottom: 10px;
    padding: 10px;
    background-color: #4caf50;
    color: white;
    border: none;
    cursor: pointer;
    width: max-content;
    border-radius: 5px;
    margin-top: 0.5rem;
  }
  
  .action-buttons button {
    background: none;
    border: none;
    cursor: pointer;
    margin: 0 5px;
    position: relative;
    transition: transform 0.2s ease, opacity 0.2s ease;
  }
  
  .action-buttons button:hover {
    transform: scale(1.2);
    opacity: 0.8;
  }
  
  .action-buttons button:hover::after {
    content: attr(data-tooltip);
    position: absolute;
    bottom: -25px;
    left: 50%;
    transform: translateX(-50%);
    background-color: #333;
    color: #fff;
    padding: 5px;
    border-radius: 4px;
    font-size: 12px;
    white-space: nowrap;
  }
  
  .action-buttons button img {
    width: 20px;
    height: 20px;
  }
  
  /* Icon Colors */
  .action-buttons button[data-tooltip="Edit"] img {
    filter: invert(50%) sepia(100%) saturate(500%) hue-rotate(90deg); /* Green */
  }
  
  </style>